import { utf8StringTruncateToSize } from "@gtmhub/shared/utils";
import { DatasourceConfig, DatasourceEntityConfig, ILookerEntity } from ".";

export const getEntityConfig = (config: DatasourceConfig, tiles: ILookerEntity[], looks: ILookerEntity[]): DatasourceEntityConfig => {
  if (config.type === "dashboard") {
    return getTileEntityConfig(config, tiles);
  }
  if (config.type === "look") {
    return getLookEntityConfig(config, looks);
  }
  return null;
};

const maxNameSize = 256;

const getTileEntityConfig = (config: DatasourceConfig, tiles: ILookerEntity[]): DatasourceEntityConfig => {
  const { tileId } = config;
  if (!tileId) {
    return null;
  }
  const tile = tiles.find((t: ILookerEntity) => t.id.toString() === tileId);
  if (!tile) {
    return null;
  }
  const tileTitle = utf8StringTruncateToSize(tile.title, maxNameSize);
  return {
    name: tileTitle,
    defaultEntityName: getSanitizedEntityName(`t-${tile.id} ${tileTitle}`),
    key: `tile_${tileId}`,
  };
};

const getLookEntityConfig = (config: DatasourceConfig, looks: ILookerEntity[]): DatasourceEntityConfig => {
  const { lookId } = config;
  if (!lookId) {
    return null;
  }
  const look = looks.find((l: ILookerEntity) => l.id.toString() === lookId);
  if (!look) {
    return null;
  }
  const lookTitle = utf8StringTruncateToSize(look.title, maxNameSize);
  return {
    name: lookTitle,
    defaultEntityName: getSanitizedEntityName(`t-${look.id} ${lookTitle}`),
    key: `look_${lookId}`,
  };
};

const getSanitizedEntityName = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/^([0-9])/, "_$1")
    .replace(/[^a-zA-Z0-9_]/g, "_")
    .replace(/_{2,}/g, "_");
};
